<template>
  <div>
    <b-toast id="emailtoast" no-close-button b-toaster-top-right variant="success" :solid=true>
      <strong>
          {{ toastText }}
      </strong>
    </b-toast>

    <b-toast id="copytoast" no-close-button b-toaster-top-right variant="success" :solid=true>
      <strong>
          {{ $t("linkcopied")  }}
      </strong>
    </b-toast>

    <modal :show="true">
      {{ $t('info') }} <b>{{ player.nick_name }}</b>:
      {{returnCodeURL}}
      <br/>
      <br/>
      <QRCode :url="returnCodeURL"/>
      <template slot="footer">
        <base-button type="primary" v-clipboard="returnCodeURL" @click="$bvToast.show('copytoast')">{{$t('copylink')}}</base-button>
        <base-button type="primary" @click="emailLink()">{{$t('emaillink')}}</base-button>
        <base-button type="secondary" @click="closeDialog()">{{$t('close')}}</base-button>
      </template>
    </modal>
  </div>
</template>

<script>
import QRCode from "@/components/QRCode.vue";
import {
  emailReturnLink,
} from "../services/APIService";

export default {
  props: ['player'],
  data() {
    return {
    };
  },
  components: {
    QRCode,
  },  
  mounted() {
    this.$bus.$on("close", () => {
      this.$bus.$emit('close-return-link-dialog');
    });
  },
  beforeDestroy() {
    this.$bus.$off("close");
  },   
  computed: {
    startOfURL() {
      return window.location.origin + "/gamecode/" + this.$store.state.main.game.gameCode + "/returncode/";
    },
    returnCodeURL() {
      return this.startOfURL + this.player.return_code;
    },
    toastText() {
      return this.$t("linkemailed") + " " + this.player.email;
    }
  },
  methods: {
    closeDialog() {
      this.$bus.$emit("close-return-link-dialog");
    },
    emailLink() {
      if (!this.player.robot) {
        // Send it for real only to humans
        emailReturnLink(
          this.$store.state.main.game.gameCode,
          this.player.id,
          this.$i18n.locale,
          this.startOfURL
);
      }

      this.$bvToast.show('emailtoast');
    },
  }
};
</script>

<i18n>
{
  "en": {
    "info": "If player exits the game by accident, the player can return by using a return link. Please forward the following link or QR-Code to the player ",
    "emaillink": "Send link via email",
    "close": "Close",
    "copylink":"Copy link to clipboard",
    "linkcopied": "Link copied to clipboard",
    "linkemailed": "Return link sent to email: "
  },
  "fi": {
    "info": "Jos pelaaja poistuu vahingossa pelistä, hän pääsee takaisin paluulinkillä. Välitä seuraava linkki tai QR-koodi pelaajalle ",
    "emaillink": "Lähetä linkki emaililla",
    "close": "Sulje",
    "copylink":"Kopioi linkki leikepöydälle",
    "linkcopied": "Linkki kopioitu leikepöydälle",
    "linkemailed": "Paluulinkki lähetetty osoitteeseen: "
  },
  "sv": {
    "info": "Om spelaren lämnar spelet av misstag kan spelaren återvända genom att använda en personlig återvändarlänk. Skicka följande länk eller QR-kod till spelaren ",
    "emaillink": "Skicka länken via e-post",
    "close": "Stäng",
    "copylink":"Kopiera länk till urklipp",
    "linkcopied": "Länken kopierades till urklipp",
    "linkemailed": "Återvändarlänken skickas till e-postmeddelandet: "
  },
  "de": {
    "info": "Wenn der Spieler das Spiel versehentlich verlässt, kann er über einen persönlichen Rückkehrlink zurückkehren. Bitte leiten Sie den folgenden Link oder QR-Code an den Spieler weiter ",
    "emaillink": "Link per E-Mail versenden",
    "close": "Schließen",
    "copylink": "Link kopieren in die Zwischenablage",    
    "linkcopied": "Link in die Zwischenablage kopiert",
    "linkemailed": "Rücksende-Link per E-Mail gesendet: "
  },
  "ko": {
    "info": "플레이어가 실수로 게임을 종료한 경우 개별 재접속링크를 사용하여 접속할 수 있습니다. 다음 링크 또는 QR 코드를 플레이어에게 전달하십시오.",
    "emaillink": "이메일로 링크 보내기",
    "close": "닫기",
    "copylink":"링크 복사",
    "linkcopied": "클립보드에 복사되었습니다",
    "linkemailed": "이메일로 전송된 링크 반환: "
  }
}
</i18n>
